import { MouseEvent, useCallback } from "react";

import { useCloseFeatureCardDialog } from "../../../hooks/useDialogs";
import { useFeatureCardModule } from "./useFeatureCardModule";
import { useResetFeatureSelect } from "../../FeatureSelector/hooks/useResetFeatureSelect";

const voidFn = () => undefined;

export const useResetFeatureCard = <Deps>(
  onReset: (param?: unknown) => void = voidFn,
  deps: Deps[] = [],
  layer?: string,
) => {
  const resetFeatureSelect = useResetFeatureSelect();
  const openDialog = useCloseFeatureCardDialog();
  const { isEdit, feature } = useFeatureCardModule();
  const resetCardCallback = useCallback(onReset, deps);

  return useCallback(
    (...args) => {
      (args[0] as MouseEvent)?.stopPropagation?.();

      if (feature === null) {
        resetCardCallback(...args);

        return;
      }

      if (isEdit) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO make resources extensible, is it ok to save memoized callback in Redux Store?
        // -- NO, it's not okay to store non-serializable variabless such as callbacks in Redux Store.
        openDialog([resetCardCallback]);
      } else {
        if (!layer || layer === feature.layer) {
          resetFeatureSelect();
        }

        resetCardCallback(...args);
      }
    },
    [feature, isEdit, layer, resetCardCallback, openDialog, resetFeatureSelect],
  );
};
